module.exports = __webpack_public_path__ + "img/20.eb3752ab.jpg";